export const getGeoLocation = (address, fn) => {
  let addressString = '';
  const addressFields = ['addressOne', 'addressTwo', 'city', 'state', 'country', 'zip'];

  addressFields.forEach(field => {
    if (address[field]) {
      addressString += address[field];
    }
  });
  if (!addressString) return fn({}, {});
  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode({
    'address': addressString,
    'region': 'US',
  }, (response) => {
    const [results] = response || [];
    const addressToReturn = {};
    let geometry = {};
    if (results) {
      geometry = results.geometry;
      addressToReturn.formattedAddress = results.formatted_address;
      const coordinates = [results.geometry.location.lng(), results.geometry.location.lat()];
      addressToReturn.coordinates = coordinates;
      addressToReturn.loc = { coordinates };
      results.address_components.forEach(component => {
        if (component.types.indexOf('locality') > -1) addressToReturn.city = component.long_name;
        if (component.types.indexOf('administrative_area_level_1') > -1) addressToReturn.state = component.long_name;
        if (component.types.indexOf('postal_code') > -1) addressToReturn.postalCode = component.long_name;
      });
    }
    fn(addressToReturn, geometry);
  });
};



// WEBPACK FOOTER //
// ./src/app/utils/address.js